export const restSinNegocio = (obj) => {
  return obj.negocio !== obj.id
    ? obj.id.replace(obj.negocio + '-', '')
    : obj.id;
};
